export interface SituationsListTypes {
  id: number;
  nome: string;
  resumo: string;
  descricao: string;
  bg_mobile: string;
  ativo: boolean;
}

export const Situations: Array<SituationsListTypes> = [
  {
    id: 3,
    nome: 'NOVA',
    resumo: 'Novas licitações',
    descricao: 'NOVA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 7,
    nome: 'ALTER',
    resumo: 'Avisos de alteração em licitações',
    descricao: 'ALTERADA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 8,
    nome: 'REAB',
    resumo: 'Avisos de reabertura de licitações',
    descricao: 'REABERTURA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 5,
    nome: 'ADIA',
    resumo: 'Licitações adiadas',
    descricao: 'ADIADA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 10,
    nome: 'ADIS',
    resumo: 'Licitações adiadas sine die',
    descricao: 'ADIADA SINE DIE',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 14,
    nome: 'ANULA',
    resumo: 'Licitações anuladas',
    descricao: 'ANULADA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 11,
    nome: 'CANCE',
    resumo: 'Licitações canceladas',
    descricao: 'CANCELADA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 6,
    nome: 'PRO',
    resumo: 'Licitações prorrogadas',
    descricao: 'PRORROGADA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 4,
    nome: 'RET',
    resumo: 'Licitações retificadas',
    descricao: 'RETIFICAÇÃO',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 13,
    nome: 'REVO',
    resumo: 'Licitações revogadas',
    descricao: 'REVOGADA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 12,
    nome: 'SUS',
    resumo: 'Licitações suspensas',
    descricao: 'SUSPENSA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 9,
    nome: 'SUSS',
    resumo: 'Licitações suspensas sine die',
    descricao: 'SUSPENSA SINE DIE',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 1,
    nome: 'URGEN',
    resumo: 'Licitações urgentes',
    descricao: 'URGENTE',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 2,
    nome: 'RETRI',
    resumo: 'Licitações retransmitidas',
    descricao: 'NOVA',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 15,
    nome: 'LE',
    resumo: 'Leilões',
    descricao: 'LEILAO',
    bg_mobile: '#a6a6a6',
    ativo: true,
  },
  {
    id: 16,
    nome: 'EDITAL',
    resumo: 'Editais Online',
    descricao: 'EDITAL',
    bg_mobile: '#a6a6a6',
    ativo: false,
  },
];
